import type { ReactNode } from 'react';

/**
 * Caps a tall list/table at `maxHeight` and scrolls within it (slim branded
 * scrollbar via .pf-scroll in theme.css), so data-heavy pages don't grow
 * unbounded down the page.
 */
export function ScrollArea({
  children,
  maxHeight = 360,
}: {
  children: ReactNode;
  maxHeight?: number;
}): JSX.Element {
  return (
    <div className="pf-scroll" style={{ maxHeight }}>
      {children}
    </div>
  );
}
